import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useTabContainerStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    indicator: {
      width: 4,
      backgroundColor: theme.oysterTheme.oyster,
    },
  }),
);

export const useTabStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: '100%',
      width: '100%',
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      fontSize: 14,
      color: theme.oysterTheme.charcoal,
      opacity: 1,
      '& svg': {
        fontSize: 24,
        marginRight: theme.spacing(2),
        fill: theme.oysterTheme.charcoal,
        color: 'inherit',
      },
      [theme.breakpoints.down('sm')]: {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        minWidth: 50,
        width: 'auto',
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
    selected: {
      fontWeight: 600,
      color: theme.oysterTheme.oyster,
    },
    labelIcon: {
      '& $wrapper > *:first-child': {
        marginBottom: 0,
      },
      [theme.breakpoints.down('sm')]: {
        minHeight: 50,
      },
    },
  }),
);
